"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var DragHandle = /*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DragHandle, _React$Component);
  function DragHandle() {
    var _getPrototypeOf2;
    var _this;
    (0, _classCallCheck2.default)(this, DragHandle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DragHandle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onMouseDown", function (e) {
      _this.props.onMouseDown.call(null, e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onTouchStart", function (e) {
      _this.props.onTouchStart.call(null, e);
    });
    return _this;
  }
  (0, _createClass2.default)(DragHandle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (!node) throw new Error('DragHandle missing element');
      node.addEventListener('mousedown', this._onMouseDown);
      node.addEventListener('touchstart', this._onTouchStart);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (!node) throw new Error('DragHandle missing element');
      node.removeEventListener('mousedown', this._onMouseDown);
      node.removeEventListener('touchstart', this._onTouchStart);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO In next major version remove the need for findDOMNode by using React.cloneElement here.
      // Update documentation to require that the element given to dragHandle is either
      // a native DOM element or forwards its props to one.
      return _react.default.Children.only(this.props.children);
    }
  }]);
  return DragHandle;
}(_react.default.Component);
exports.default = DragHandle;
module.exports = exports.default;
module.exports.default = exports.default;